import db from '../../js/db'
import * as types from '../mutations-types'
import {
  vuexfireMutations
} from 'vuexfire'
import Constants from '../../js/constants'
import moment from "moment";
// import store from '../'

const state = {
  last: null,
  all: null, // mi serve null (che è != []) per poter mostrare "loading" mentre l'api processa
  endAt: null,
  loading: false,
  noMore: false
}

// getters
const getters = {
  astaLogs: state => state.all,
  astaLogsLast: state => state.last,
  loadingLogs: state => state.loading,
  noMoreLogs: state => state.noMore
}

// actions
const actions = {
  fetchAstaLogsLast() {
    return db.fetchAstaLogsLast()
  },
  setAstaLogsAll({
    state
  }, nItems) {
    let endAt = state.endAt
    return db.setAstaLogsAll(nItems, endAt)
  },
  clearAstaLogsAll({
    commit
  }) {
    commit(types.ASTA_LOGS_ALL_CLR)
  },

}

function convert(log) {
  let output = {}
  if (log.t) output.type = log.t
  if (log.cid) output.calciatore_id = log.cid
  if (log.sid) output.squadra_id = log.sid
  if (log.sn) output.nomeSquadra = log.sn
  if (log.ts) output.ts = log.ts
  if (log.ts) output.tsFormatted = moment(log.ts).format("DD/MM/YY HH:mm:ss")
  if (log.p) output.prezzo = log.p
  if (log.po) output.prezzoOld = log.po
  if (log.co) output.crediti = log.c
  if (log.co) output.creditiOld = log.co
  if (log.ce) output.creditiExtra = log.ce
  if (log.key) output.key = log.key
  return output
}

// mutations
const mutations = {
  [types.ASTA_LOGS_ALL](state, logs) {
    if (state.all == null) {
      state.all = []
    }
    let nLogs = logs.length
    if (nLogs == 0) {
      state.noMore = true
      state.endAt = null
      return
    }
    let i
    for (i in logs) {
      // console.log(i + ") " + store.getters.calciatori[logs[i].cid].calciatore)
      if (nLogs == Constants.LOG_PAGINATOR + 1) { // + 1 per il cursor
        if (i < nLogs - 1) { // - 1 per il cursor
          state.all.push(convert(logs[i]))
        }
      } else {
        state.all.push(convert(logs[i]))
        state.noMore = true
        state.endAt = null
      }
    }

    // salvo l'ultima key per il cursor paginator
    if (nLogs > 0) {
      state.endAt = logs[i].key
    }
  },
  [types.ASTA_LOGS_LOADING](state, val) {
    state.loading = val;
  },
  [types.ASTA_LOGS_LAST](state, log) {
    state.last = convert(log);
  },
  [types.ASTA_LOGS_ALL_CLR](state) {
    state.endAt = null;
    state.all = null;
    state.loading = false;
    state.noMore = false;
  },
  [types.ASTA_LOGS_CLR](state) {
    state.last = null;
    state.all = null;
    state.endAt = null;
    state.loading = false;
    state.noMore = false;
  },
  ...vuexfireMutations
}


export default {
  state,
  getters,
  actions,
  mutations
}
